import { render, staticRenderFns } from "./CourseSectionViewHeader.vue?vue&type=template&id=099e3857&"
import script from "./CourseSectionViewHeader.vue?vue&type=script&lang=js&"
export * from "./CourseSectionViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports